import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { LoadingButton } from "@atlaskit/button";

import { trackSiteNameCreation } from "@/components/signup/utils";

export const ButtonSubmit = ({
    submitting,
    hasSubmitted,
    formError,
    submitButtonLabel
}: {
    submitting: boolean;
    hasSubmitted: boolean;
    formError: boolean;
    submitButtonLabel: string;
}) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    return (
        <LoadingButton
            appearance="primary"
            css={submitButtonCss}
            isDisabled={submitting || (hasSubmitted && !formError)}
            isLoading={submitting || (hasSubmitted && !formError)}
            onClick={() => trackSiteNameCreation(createAnalyticsEvent)}
            shouldFitContainer={true}
            type="submit"
        >
            {submitButtonLabel}
        </LoadingButton>
    );
};

const submitButtonCss = css({
    alignItems: "center !important",
    fontWeight: 400,
    height: "45px !important"
});
